import React, {useEffect} from 'react';
import {Dialog, Heading, Modal} from 'react-aria-components';
import './ConfirmationModal.css';
import DefaultButton, {WarningButton} from "../Buttons/DefaultButton/DefaultButton.js";

function ConfirmationModal({ title, message, onConfirm, onCancel, className } : {
    title: string;
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
    className?: string;
}) {

    // Add the event listener manually
    useEffect(() => {
        const overlay = document.querySelector(".overlay");
        const handleClick = (e) => {
            if (e.target === overlay) {
                onCancel(); // Close the modal when clicking on the overlay
            }
        };

        if (overlay) {
            overlay.addEventListener("click", handleClick);
        }

        // Cleanup event listener on unmount or when modal closes
        return () => {
            if (overlay) {
                overlay.removeEventListener("click", handleClick);
            }
        };
    }, [onCancel]);

    return <Modal
        isOpen
      isDismissable
      isKeyboardDismissDisabled
      className="overlay"
    >
      <Dialog aria-label={title} className={className? "modal "+className : "modal"}>
          <Heading className="title">{title}</Heading>
          <p className="description">{message}</p>
          <div className="buttons">
              <DefaultButton text="Cancel" onPress={onCancel}/>
              <WarningButton
                  text="Confirm"
                  onPress={onConfirm}
                  href={undefined}
                  className={undefined}
                  oneClick={undefined}
              />
          </div>
      </Dialog>
  </Modal>
}

export default ConfirmationModal;